module.exports = __webpack_public_path__ + "static/Omise-c9b4c90027169311775881582d09f9a5.svg";